<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { debounceTime, tap } from "rxjs/operators";

  import type { ProductData } from "$lib/def/landing";
  import { RxWritable } from "$lib/util/obs";
  import { fetchBackups } from "./server";
  import Product from "$lib/ui/home/groc/Product.svelte";
  import Search from "$lib/ui/form/Search.svelte";
  import Grid from "$lib/ui/layout/Grid.svelte";
  import { formatCurrency } from "$lib/util/format";
  import { getPlaceHolderImgUrl } from "mock/image";
import { PNP_IMG_HOST } from "$lib/serv/core/env";

  const dispatch = createEventDispatcher();

  export let product: ProductData & { alternative_item?: ProductData };

  const search$ = new RxWritable("");
  const search$$ = search$.pipe(debounceTime(1000));

  $: backups$ = fetchBackups(product, $search$$).pipe(tap(() => console.log("BACKUPS FETCHED")));

  const toArr = (p?: any[] | null) => (p ? p : []) as ProductData[];
  $: imgURL = product.alternative_item?.image_url?.filename
    ? `${PNP_IMG_HOST}/${product.alternative_item.image_url.filename}`
    : product?.url
    ? `${PNP_IMG_HOST}/${product.url}`
    : getPlaceHolderImgUrl('Mr D');
</script>

{#if product.disable_backup}
  <div>Backups are disabled for this product</div>
{:else}
  <div id="top">
    {#if product}
      <div class="product-info-container">
        <article>
          <img src={imgURL} alt={product.label}>
          <div id="label" class="mr body-m book">{product.label}</div>
          <div id="price" class="body-m bold m-0">{formatCurrency(product.price_now)}</div>
        </article>
        <Search classes='stretch' bind:value={$search$} placeholder="Search" />
      </div>

      <button class="backupCheck" on:click={() => (product.alternative_item ? dispatch("backup", null) : null)}>
        <div class:checked={!product.alternative_item}>
          {#if !product.alternative_item}
            <span class="icon-check-20" />
          {/if}
        </div>
        <div>
          <p class="bold">No backup</p>
          <span>
            {#if !product.alternative_item}
              We'll refund you if it's sold out
            {:else}
              Refund me if it's sold out
            {/if}
          </span>
        </div>
      </button>
    {/if}
  </div>
  {#if $backups$}
    {@const {items, loading, error} = $backups$}
    <Grid
      type="aisle"
      cache={{ loading, payload: { items, alt: product.alternative_item }, error }}
      key={v => toArr(v?.alt ? [v.alt, ...toArr(v.items)] : v?.items)}
      let:item
    >
      <Product
        {item}
        asBackup={true}
        isSelected={item?.catalogue_key === product?.alternative_item?.catalogue_key}
        on:product={(e) => dispatch("backup", e.detail)}
      />
    </Grid>
  {/if}
{/if}

<style lang="scss">
  @use "screen";
  @use "color";

  #top {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 16px;
    padding: 1rem 0 0 0;
    @media(screen.$md) { padding: 1.5rem 0 0 0; }
    .product-info-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;
      @media(screen.$md) { 
        gap: 3rem;
        flex-direction: row; 
        justify-content: space-between;
      }
      article {
        display: flex;
        margin-bottom: 1rem;
        align-items: center;
        @media(screen.$md) { 
          width: 50%;
          align-items: flex-start;
        }
        img {
          width: 82px;
          max-height: 82px;
          aspect-ratio: 5/5;
          margin-right: 1rem;
          border-radius: 10px;
        }
        div {
          margin: 0;
          &:nth-of-type(1) {
            flex: 4;
            margin-right: 1rem;
            max-width: 70%;
          }
          &:nth-of-type(2) {
            flex: 1;
            text-align: right;
            @media(screen.$md) {
              text-align: left;
            }
          }
        }
      }
    }
    .backupCheck { 
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 1rem;
      border-radius: 20px;
      background: color.$object-elevation-3dp;
      width: 100%;
      @media(screen.$sm) { width: auto; }
      div {
        &:nth-of-type(1) {
          width: 20px;
          height: 20px;
          border: 2px solid color.$separator;
          border-radius: 4px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          &.checked {
            background: color.$primary-variant;
            border: 2px solid color.$primary-variant;
          }
        }
        &:nth-of-type(2) {
          margin-left: .75rem;
          p { text-align: left; margin-bottom: 0; }
          span { color: color.$on-background-medium-importance; }
        }
      }
    }
  }

  // #selected-backup {
  //   display: flex;
  //   align-items: center;

  //   margin-right: 16px;

  //   @media (screen.$max-md) {
  //     margin-right: 0;
  //     margin-bottom: 16px;
  //   }

  //   #img {
  //     background-repeat: no-repeat;
  //     background-position: center;
  //     background-size: cover;

  //     border-radius: 12px;
  //     min-height: 75px;
  //     min-width: 75px;
  //     margin-right: 12px;
  //   }

  //   .mr {
  //     margin-right: 8px;
  //   }
  // }
</style>
